export default {
  setLoading (state, payload) {
    state.loading = payload
  },
  setPractice (state, payload) {
    if (payload) {
      const featureFlagState = Object.keys(this.state.dictionariesStates.dictionaryFeatureFlagState);
      if (payload.journalAvailable) payload.journalAvailable = featureFlagState.find(flagState => flagState.toLowerCase() === payload.journalAvailable.toLowerCase()) || payload.journalAvailable
      if (payload.smartSurveyAvailable) payload.smartSurveyAvailable = featureFlagState.find(flagState => flagState.toLowerCase() === payload.smartSurveyAvailable.toLowerCase()) || payload.smartSurveyAvailable
      if (payload.swapAvailable) payload.swapAvailable = featureFlagState.find(flagState => flagState.toLowerCase() === payload.swapAvailable.toLowerCase()) || payload.swapAvailable
      if (payload.surveyAvailable) payload.surveyAvailable = featureFlagState.find(flagState => flagState.toLowerCase() === payload.surveyAvailable.toLowerCase()) || payload.surveyAvailable
    }

    state.practice = payload
  },
  setPractices (state, payload) {
    state.practices = payload
  },
  setPagination (state, payload) {
    state.pagination = { ...payload }
  },
  setPracticePatients (state, payload) {
    state.practicePatients = payload
  },
  setPracticeUsers (state, payload) {
    state.practiceUsers = payload
  },
  setPracticeUser (state, payload) {
    if (payload) {
      const featureFlagState = Object.keys(this.state.dictionariesStates.dictionaryFeatureFlagState);
      if (payload.surveyAvailable) payload.surveyAvailable = featureFlagState.find(flagState => flagState.toLowerCase() === payload.surveyAvailable.toLowerCase()) || payload.surveyAvailable
    }
    state.practiceUser = payload
  },
  setPracticeUserPatients (state, payload) {
    state.practiceUserPatients = payload
  },
  setPracticesFilters (state, payload) {
    state.practicesFilters = payload
  },
  setPracticePatientsFilters (state, payload) {
    state.practicePatientsFilters = payload
  },
  setPracticeUsersFilters (state, payload) {
    state.practiceUsersFilters = payload
  },
  setPracticeUserPatientsPagination (state, payload) {
    state.practiceUserPatientsPagination = { ...payload }
  },
  setPracticeUserAdvisorsDashboard (state, payload) {
    state.practiceUserAdvisorsDashboard = payload
  },
}
